<template>
  <b-row>
    <b-modal id="modal-1" size="lg" title="Observaciones" ref="modal1">

        <b-list-group>
          <b-list-group-item v-for="(val,i) in manyvalue" v-bind:key="i"
            :variant="val.type==='public'?'success':(val.type==='private'?'secondary':'')">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">{{areas[val.role]}} [{{val.username}}]</h5>
              <small>{{types[val.type]}}</small>
            </div>
            <p class="mb-1">
              {{val.text}}
            </p>
          </b-list-group-item>
        </b-list-group>

      <b-form-textarea
        id="textarea-chat"
        v-model="text"
        placeholder="nueva observación..."
        rows="3"
      ></b-form-textarea>
      <b-row>
        <b-col sm="8">
          <b-form-select v-model="type" :options="types"></b-form-select>
        </b-col>
        <b-col sm="4">
          <b-button block variant="success" v-on:click="agregar">Agregar</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-col sm="12">
      <b-row>
        <b-col md="2"><b-button @click="show">{{manyvalue.length}} Observaciones(s)</b-button></b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import FormComponentBase from './FormComponentBase'
import { mapState } from 'vuex'

export default {
  name: 'FormComponentChat',
  extends: FormComponentBase,
  /* components: {
    FormComponent: () => import('./FormComponent')
  }, */
  data () {
    return {
      manyvalue: [],
      modal: false,
      types: {
        public: 'Observación Oficial',
        private: 'Mensaje Interno',
        feedback: 'Observación para sistemas'
      },
      areas: {
        admin: 'Administrador de Sistema',
        inspection_1: 'Inspector',
        inspection_2: 'Jefe de Inspección',
        inspection_3: 'Oficina Técnica',
        inspection_4: 'Gerencia'
      },
      type: 'public',
      text: ''
    }
  },
  computed: {
    ...mapState({
      'user': 'user'
    }),
    role: function () {
      if (this.user && this.user.roles) {
        for (var i = 0; i < this.user.roles.length; i++) {
          if (this.user.roles[i] === '_admin') {
            return 'admin'
          }
          var levels = ['inspection_4', 'inspection_3', 'inspection_2', 'inspection_1']
          for (var j in levels) {
            if (this.user.roles[i] === levels[j] || this.user.roles[i] === levels[j] + '_57' ||
              this.user.roles[i] === levels[j] + '_88') {
              return levels[j]
            }
          }
        }
      }
      return null
    }
  },
  watch: {
    value: function (val) {
      this.$set(this, 'manyvalue', val)
      this.$emit('valuechange', val)
    }
  },
  mounted () {
    if (this.value) {
      this.manyvalue = this.value
    }
  },
  methods: {
    show () {
      this.$refs['modal1'].show()
    },
    eliminar (i) {
      var obj = this
      this.$dialog.confirm('Seguro que desea eliminar el elemento?', { okText: 'Eliminar', cancelText: 'Cancelar' })
        .then(function () {
          obj.$delete(obj.manyvalue, i)
        }).catch(function () {
          console.log('Clicked on cancel')
        })
    },
    agregar () {
      this.manyvalue.push({
        type: this.type,
        text: this.text,
        username: this.user.name,
        role: this.role
      })
      this.$emit('input', this.manyvalue)
      this.text = ''
      console.log(this.manyvalue)
    }
  }
}
</script>
